import saga from "./saga";
import slice from "./slices";

const layout = {
  slice,
  saga,
};

export default layout;
